'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from 'next/image';

import { HousingPropertyDetail } from '@eliadmin/core/src/api/housing/housing-types';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useState } from 'react';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';

export function HousingImages({ housing }: { housing: HousingPropertyDetail }) {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div
        className={cn(
          'custom-container',
          'grid grid-cols-1 gap-2 overflow-hidden rounded-[24px] sm:grid-cols-2 md:gap-3',
        )}
      >
        <div className="relative col-span-1 h-[260px] cursor-pointer transition-all hover:opacity-80 sm:h-full">
          <Image
            src={housing?.image?.url}
            alt={resolveImageAlt(housing?.image, housing?.name)}
            onClick={handleOpenGallery(housing?.image, 0)}
            fill
            className="z-0 object-cover object-center"
            priority
          />
        </div>
        <div className="col-span-1 grid w-full grid-cols-2 gap-2 md:gap-3">
          {housing?.images?.slice(0, 4).map((image, index) => (
            <div
              key={image?.name}
              className="relative h-[125px] w-full cursor-pointer transition-all hover:opacity-80 sm:h-[150px] lg:h-[190px] xl:h-[219px]"
            >
              <Image
                src={image?.url}
                alt={resolveImageAlt(image, undefined)}
                onClick={handleOpenGallery(housing?.images, index)}
                fill
                className="z-0 object-cover object-center"
                loading="eager"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
